module.exports = __webpack_public_path__ + "media/src/web/images/logo-white-6cd40b68e04bfdbbcd4455852d49243e.png";